(() => {
  const layer = document.querySelector('[data-contact-layer]');
  const windowPanel = layer?.querySelector('.contact-window');
  const closeButton = layer?.querySelector('[data-contact-close]');
  const launchers = [...document.querySelectorAll('[data-contact-launch]')];
  if (!layer || !windowPanel || !launchers.length) return;

  let returnFocus = null;

  function openContact(event) {
    returnFocus = event?.currentTarget || document.activeElement;
    layer.hidden = false;
    document.body.classList.add('contact-is-open');
    windowPanel.focus();
    window.saunaTrack?.('contact_window_opened', {
      location: event?.currentTarget?.closest('footer') ? 'footer' : 'floating_launcher'
    });

    const requestedPath = event?.currentTarget?.dataset.contactOpenPath;
    if (requestedPath) windowPanel.querySelector(`[data-contact-path="${requestedPath}"]`)?.focus();
  }

  function closeContact() {
    layer.hidden = true;
    document.body.classList.remove('contact-is-open');
    returnFocus?.focus?.();
  }

  function continueTo(path) {
    const target = path === 'wholesale'
      ? document.querySelector('[data-open-wholesale]')
      : document.querySelector('[data-open-inquiry]');

    window.saunaTrack?.('contact_topic_selected', { topic: path });
    closeContact();

    if (target) {
      target.click();
      return;
    }

    const home = layer.dataset.homeUrl || '/';
    window.location.href = `${home}${path === 'wholesale' ? '#wholesale' : '#configure'}`;
  }

  launchers.forEach((button) => button.addEventListener('click', openContact));
  closeButton.addEventListener('click', closeContact);
  layer.addEventListener('click', (event) => {
    if (event.target === layer) closeContact();
  });
  layer.querySelectorAll('[data-contact-path]').forEach((button) => {
    button.addEventListener('click', () => continueTo(button.dataset.contactPath));
  });
  layer.querySelectorAll('.contact-direct a').forEach((link) => {
    link.addEventListener('click', () => window.saunaTrack?.('direct_contact_opened', { channel: link.textContent.trim().toLowerCase() }));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !layer.hidden) closeContact();
  });
})();
